/**
 * @file SelectionCheckIcon.jsx
 * @exports SelectionCheckIcon
 */
import React from 'react'

const SelectionCheckIcon = function SelectionCheckIcon ({ color, width, height }) {
  let defaultColor = '#23ce6b'
  let defaultHeight = '26'
  let defaultWidth = '26'

  if (color) {
    defaultColor = color
  }

  if (width) {
    defaultWidth = width
  }

  if (height) {
    defaultHeight = height
  }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={defaultWidth}
      height={defaultHeight}
      viewBox='0 0 26 26'
    >
      <circle cx='13' cy='13' r='13' fill={defaultColor} />

      <path
        fill='none'
        stroke='#fff'
        strokeLinecap='round'
        strokeWidth='3'
        d='M6 12.222L11.353 20 19 6'
      />
    </svg>
  )
}

export default SelectionCheckIcon
